export default {
    API_BASE_URL: 'https://apipreprod.elhadepilacionlaser.com',
    // API_BASE_URL: 'https://api.elhadepilacionlaser.com',
    // API_BASE_URL: 'http://api.elha.local/app_dev.php',
    API_BASE_SUFFIX: '/v2',
    ACCESS_TOKEN: 'MDkxOWI0YjI5MDlhMWYyYmZjNmI1YWIwZTJmOGYwOWJlMDFlNWRiZjM3MGFjODRiYThjZDk5MjA2NzA5NDRhZA'
}
